import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=32d56743&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=ts"
export * from "./Branches.vue?vue&type=script&lang=ts"
import style0 from "./Branches.vue?vue&type=style&index=0&id=32d56743&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d56743",
  null
  
)

export default component.exports